import { useHistory } from 'react-router-dom';

import { Lease, Property } from '../models';
import DocumentPreviewSelector from '../components/DocumentPreviewSelector';
import { useLeaseQuery, usePropertyInfoQuery } from '../utils/queries';
import { useLeasingUrlParams } from '../hooks/useLeasingUrlParams';

function LandlordLeasePreview() {
  const history = useHistory();
  const { leaseId, propertyId } = useLeasingUrlParams();

  const leaseQuery = useLeaseQuery(leaseId, { enabled: !!leaseId });
  const propertyQuery = usePropertyInfoQuery(propertyId, !!propertyId);

  const lease = leaseQuery.data;
  const property = propertyQuery.data ? new Property(propertyQuery.data) : undefined;

  if (!lease || leaseQuery.isPending) {
    return null;
  }

  function onCloseLeasePreview() {
    history.push(Lease.getSummaryPath(Number(leaseId)));
  }

  return (
    <DocumentPreviewSelector
      leaseId={Number(leaseId)}
      lease={lease}
      property={property}
      onClose={onCloseLeasePreview}
    />
  );
}

export default LandlordLeasePreview;
